var menu = new function () {
    this.menu;
    
    this.doToggleMenu = function (event, el) {
        $('body').toggleClass('menu-open');
        $('#header-menu').toggleClass('header-upper__menu--open');
    };
    this.doToggleSubMenu = function (event, el) {
        if ($(window).width() < 992) {
            $parent = $(el).parent();
            $('.header-categories').toggleClass('header-categories--open');
            if ($parent.hasClass('header-categories-list__item')) {
                // open
                $parent.find('.header-categories-list__menu').addClass('header-categories-list__menu--mobile-open');
            } else {
                $(el).closest('.header-categories-list__menu').removeClass('header-categories-list__menu--mobile-open');
            }
        } else {
            window.location = $(el).attr('href');
        }
    };
}

document.addEventListener('DOMContentLoaded', function () {
    const moreToggle = document.querySelector('.more-toggle');
    const moreMenu = document.querySelector('.header-nav-list__item--more');

    if (moreToggle && moreMenu) {
        moreToggle.addEventListener('click', (e) => {
            e.preventDefault();
            moreMenu.classList.toggle('is-visible');
        });

        document.addEventListener('click', (e) => {
            if (!moreToggle.contains(e.target) && !moreMenu.contains(e.target)) {
                moreMenu.classList.remove('is-visible');
            }
        });
    }
});